import React from 'react'
import {FaCode, FaGlobeAsia} from 'react-icons/fa'

const card = ({title, description, liveLink = '', sourceCode = '', thumb = ''}) => {
    return (
        <div className="w-full border border-black cursor-pointer">
            {
                thumb !== '' && 
                <img src={thumb} className="w-full" alt="thumbnail"/>
            
            }
            <div className="flex flex-col p-4">
                <h3 className="text-primary font-semibold text-2xl py-5"> {title} </h3>
                <p className="font-light text-md py-3"> {description} </p>
                <span> 
                    {liveLink !== '' && <a className="inline-block px-3 py-3 text-2xl canvas-hover" href={liveLink}> <FaGlobeAsia /> </a> }
                    { sourceCode !== '' &&  <a className="inline-block px-3 py-3 text-2xl canvas-hover" href={sourceCode}> <FaCode /> </a> }
                </span>
            </div>
        </div>
    )
}

export default card
